import { Switch, Td, Tr, useToast } from '@chakra-ui/react';
import axios from 'axios';
import { useHistory } from 'react-router-dom';

export const BlogTableRow = ({ blog, page, total, index, onUpdateRow }) => {
  const history = useHistory();
  const toast = useToast();
  const id = total - (page - 1) * 10 - index;

  const handleClick = () => {
    history.push('/admin/blogs/write', { blog });
  };

  const handleToggle = async (e) => {
    e.stopPropagation();
    const isPublished = e.target.checked;
    try {
      await axios.patch(`/admin/blogs/${blog.id}`, { isPublished });
      onUpdateRow({ ...blog, isPublished });
      toast({ title: '수정되었습니다.', status: 'success', isClosable: true });
    } catch (error) {
      toast({
        title: error.response?.data?.message || '오류가 발생했습니다.',
        status: 'error',
        isClosable: true,
      });
    }
  };

  return (
    <Tr onClick={handleClick} cursor="pointer">
      <Td>{id > 0 ? id : ''}</Td>
      <Td>{blog.title}</Td>
      <Td>{blog.category?.name || '-'}</Td>
      <Td>{blog.modifier?.name || '-'}</Td>
      <Td>{blog.viewCount}</Td>
      <Td onClick={(e) => e.stopPropagation()}>
        <Switch isChecked={blog.isPublished} onChange={handleToggle} />
      </Td>
      <Td>{new Date(blog.createdAt).toLocaleDateString()}</Td>
    </Tr>
  );
};
